import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import UniversalDrawCounterLoader from '../../counters/UniversalDrawCounterLoader.lazy';
import { RootState } from '../redux/store';

import { isPremierDubai } from 'utils/template';

function DrawCounter({ isMobile = true }: Readonly<{ isMobile?: boolean }>) {
    const { t } = useTranslation();
    const { lottery, displayDrawCounter, nextDraw, nextNextDraw } = useSelector((state: RootState) => state.playStore);

    if (!displayDrawCounter && !isPremierDubai()) {
        return null;
    }

    const getMobileCardBody = () => (
        <div className="card-body">
            <div className="draw-date font-bold countdown countdown-type-clock float-left mb-2 mr-4">
                <UniversalDrawCounterLoader
                    nextDraw={nextDraw}
                    nextNextDraw={nextNextDraw}
                    lottery={lottery.display_slug}
                />
            </div>
        </div>
    );

    const getDesktopCardBody = () => (
        <div className="card-body card-cols-separated p-0 d-md-flex">
            <div className="row d-md-flex flex-fill justify-content-center">
                <div className="col-sm-10 col-xs-12 pt-4 pb-4">
                    <div className="draw-date font-bold countdown countdown-type-clock">
                        <UniversalDrawCounterLoader
                            nextDraw={nextDraw}
                            nextNextDraw={nextNextDraw}
                            lottery={lottery.display_slug}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div className="card options-card">
            <div className="card-header">{t('playPicker.nextDraw')}</div>
            {isMobile ? getMobileCardBody() : getDesktopCardBody()}
        </div>
    );
}

export default DrawCounter;
